<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-card class="mx-auto pa-0" width="100" height="100" outlined v-if="area != null">
        <v-layout justify-center>
            <table>
                <tr>
                    <td style="text-align:center">
                        <v-avatar v-if="icon != null" size="80">
                            <v-img :src="weatherIconPath" />
                        </v-avatar>
                    </td>
                </tr>
                <tr>
                    <td>                    
                    </td>
                </tr>
            </table>
            <div v-if="weather != null && weather.environment != null" style="position:absolute; top:64px">
                <span style="font-family:Orbitron; font-size:20px; font-weight:bold;">{{weather.environment.temp.toFixed(1)}}</span>
                <span>℃</span>
            </div>
        </v-layout>
    </v-card>
                <!-- <template v-if="!$vuetify.breakpoint.xs">
                    <v-card class="mx-auto pa-1" v-if="area != null">
                        <Title dense :title="area.city+'の現在の天気'">
                            <v-spacer />
                            <v-btn icon @click="refreshWeather"><v-icon small>mdi-refresh</v-icon></v-btn>
                        </Title>
                        <template v-if="weather != null">
                            <table>
                                <tr>                    
                                    <td style="text-align:center">
                                        <v-avatar v-if="icon != null" size="100" class="ma-2">
                                            <v-img :src="weatherIconPath" />
                                        </v-avatar>
                                    </td>
                                    <td style="width:100%">
                                        <table style="font-size:14px; font-family:Abel">
                                            <tr>
                                                <td colspan="2">
                                                    <v-icon small>mdi-thermometer</v-icon>
                                                    <span style="font-size:40px;">{{weather.environment.temp.toFixed(1)}}</span>
                                                    <span style="font-size:14px;">℃</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><v-icon small>mdi-water</v-icon></td>
                                                <td>{{weather.environment.humidity}}<span style="font-size:10px">%</span></td>
                                            </tr>
                                            <tr>
                                                <td><v-icon small>mdi-weather-windy</v-icon></td>
                                                <td style="font-size:12px">{{windVec(weather.wind.deg)}}向き{{weather.wind.speed}}<span style="font-size:10px">m</span></td>
                                            </tr>                    
                                        </table>
                                    </td>
                                </tr>
                            </table>
                            <v-divider />
                            <div style="width:100%; text-align:right; font-size:xx-small" class="pr-1" >{{weather.dateTime}}</div>
                        </template>
                    </v-card>
                </template>
                <template v-else>
                    <v-card class="mx-auto pa-0" v-if="area != null">
                        <template v-if="weather != null">
                            <table>
                                <tr>                    
                                    <td style="text-align:center">
                                        <v-avatar v-if="icon != null" size="48" class="ma-2">
                                            <v-img :src="weatherIconPath" />
                                        </v-avatar>
                                    </td>
                                    <td style="width:100%">
                                        <table style="font-size:11px; font-family:Abel">
                                            <tr>
                                                <td colspan="2">
                                                    <v-icon small>mdi-thermometer</v-icon>
                                                    <span style="font-size:20px;">{{weather.environment.temp.toFixed(1)}}</span>
                                                    <span style="font-size:11px;">℃</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><v-icon small>mdi-water</v-icon></td>
                                                <td>{{weather.environment.humidity}}<span style="font-size:10px">%</span></td>
                                            </tr>
                                            <tr>
                                                <td><v-icon small>mdi-weather-windy</v-icon></td>
                                                <td style="font-size:12px">{{windVec(weather.wind.deg)}}向き{{weather.wind.speed}}<span style="font-size:10px">m</span></td>
                                            </tr>                    
                                        </table>
                                    </td>
                                </tr>
                            </table>
                            <v-divider />
                            <div style="width:100%; text-align:right; font-size:xx-small" class="pr-1" >{{area.city}}/{{weather.dateTime}}</div>
                        </template>
                    </v-card>
                </template>
            </td>
        </tr>
    </table> -->
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    export default {
        components: {
            Title
        },
        data: function () {
            return {
                weather: null,
                area: null,
                timerID: null,
                icon: null,
                iconList: [
                    {description: "曇りがち", icon:"cloudy"},
                    {description: "雲", icon:"cloudy"},
                    {description: "薄い雲", icon:"cloudy"},
                    {description: "晴天", icon:"clear"},
                    {description: "適度な雨", icon:"rain02"},
                    {description: "小雨", icon:"rain02"},
                    {description: "にわか雨", icon:"rain02"},
                    {description: "弱いにわか雨", icon:"rain02"},
                    {description: "強いにわか雨", icon:"rain02"},
                    // {description: "霧", icon:"rain02"},
                ],
                windVecList: [
                    {from:0, to:11.25,vec:'北'},
                    {from:0, to:33.75,vec:'北北東'},
                    {from:0, to:56.25,vec:'北東'},
                    {from:0, to:78.75,vec:'東北東'},
                    {from:0, to:101.25,vec:'東'},
                    {from:0, to:123.75,vec:'東南東'},
                    {from:0, to:146.25,vec:'南東'},
                    {from:0, to:168.75,vec:'南南東'},
                    {from:0, to:191.25,vec:'南'},
                    {from:0, to:213.75,vec:'南南西'},
                    {from:0, to:236.25,vec:'南西'},
                    {from:0, to:258.75,vec:'西南西'},
                    {from:0, to:281.25,vec:'西南西'},
                    {from:0, to:303.75,vec:'西北西'},
                    {from:0, to:326.25,vec:'北西'},
                    {from:0, to:348.75,vec:'北北西'},
                    {from:0, to:360,vec:'北'},
                ]
            }
        },
        computed: {
            loggedInUserData: function () {
                return this.$store.getters["loggedInUserData"]
            },
            areas: function () {
                return this.$store.getters["areas"]
            },
            weatherIconPath: function () {
                if (this.icon == null) {
                    return ""
                }
                return require("@/assets/weather/"+this.icon+".png")
            },
        },
        watch: {
            loggedInUserData: {
                handler: function (value, old) {
                    console.log("loggedInUserData changed")
                    this.refreshWeather()
                },
                deep: true
            },
            areas: {
                handler: function (value, old) {
                    this.refreshWeather()
                },
                deep: true
            }
        },
        mounted: function () {

            this.refreshWeather()            
        },
        beforeDestroy: function () {
            if (this.timerID != null) {
                clearTimeout(this.timerID)
            }
        },
        methods: {
            windVec: function (deg) {
                const vec = this.windVecList.find((v)=>deg >= v.from  && deg <= v.to) 
                if (vec == null) {
                    return "unknown"
                }
                return vec.vec
            },
            refreshWeather: function () {
                const self = this
                if (this.timerID != null) {
                    clearTimeout(this.timerID)
                }
                if (this.loggedInUserData != null && this.loggedInUserData.address.areaID != null && this.loggedInUserData.address.areaID != "") {
                    this.area = this.areas.find((v)=>v.area == this.loggedInUserData.address.areaID)
                } else {
                    this.area = null
                    return
                }
                if (this.loggedInUserData != null) {
                    try {
                        db.collection("areas").doc(this.loggedInUserData.address.areaID).collection("weather_histories").doc("last").get().then(function(doc){
                            if (doc.exists) {
                                self.weather = doc.data()
                                const icon = self.iconList.find((v)=>v.description == self.weather.weather.description)
                                if (icon != null) {
                                    self.icon = icon.icon
                                } else {
                                    self.icon = "chancerain"
                                }
                                console.log(self.weather, icon, self.icon)
                            }
                        }).catch (function (error) {
                            self.mi_writeLog("WeatherViewer2/refreshWeather", "最新天候データの取得失敗(1)("+error+")")
                        })
                        this.timerID = setTimeout(this.refreshWeather, 60000 * 30)
                    } catch (error) {
                        self.mi_writeLog("WeatherViewer2/refreshWeather", "最新天候データの取得失敗(2)("+error+")")
                    }
                }
            }
        }
    }
</script>

<style scoped>
    /* @import url('https://fonts.googleapis.com/css2?family=Abel&display=swap'); */
    @import url('https://fonts.googleapis.com/css2?family=Orbitron&display=swap');
</style>
